import { createClient } from '@supabase/supabase-js';

const CLIENT_REGISTRY_KEY = '__climoraxSupabaseClientRegistry__';

function getClientRegistry() {
  if (!globalThis[CLIENT_REGISTRY_KEY]) {
    globalThis[CLIENT_REGISTRY_KEY] = new Map();
  }
  return globalThis[CLIENT_REGISTRY_KEY];
}

export function getOrCreateSupabaseClient(url, key, options = {}, identity = 'main') {
  const storageKey = options?.auth?.storageKey || 'no-storage';
  const registryKey = `${identity}:${url}:${storageKey}`;
  const registry = getClientRegistry();
  if (!registry.has(registryKey)) {
    registry.set(registryKey, createClient(url, key, options));
  }
  return registry.get(registryKey);
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const projectHost = (() => {
  try { return new URL(supabaseUrl).hostname.split('.')[0]; }
  catch { return 'climorax'; }
})();

export const supabase = getOrCreateSupabaseClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: `climorax-auth-${projectHost}`,
  },
}, 'main');
